'use strict';

const SELECTOR = '.home__toolkit-slider';
// Matches the .g-32 gap (2rem = 32px) removed from CSS on swiper-wrapper
const SPACE_BETWEEN = 32;

function fixSliderSpacing(swiper) {
    if (!swiper || !swiper.el || !swiper.el.closest(SELECTOR)) {
        return;
    }

    swiper.params.spaceBetween = SPACE_BETWEEN;
    swiper.originalParams.spaceBetween = SPACE_BETWEEN;

    swiper.update();

    if (swiper.params.loop) {
        swiper.slideToLoop(0, 0, false);
    } else {
        swiper.slideTo(0, 0, false);
    }
}

export default function HomeToolkitSlider() {
    const container = document.querySelector(SELECTOR);
    if (!container) return;

    function tryFix(el) {
        if (!el || el.dataset.w4fSpacingFixed || !el.closest(SELECTOR)) return;
        if (!el.swiper) return;
        el.dataset.w4fSpacingFixed = '1';
        fixSliderSpacing(el.swiper);
    }

    // MutationObserver catches swiper-initialized being added at the exact moment
    // Swiper finishes init — no timing race with DOMContentLoaded order
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            var el = mutation.target;
            if (
                el.classList &&
                el.classList.contains('swiper-initialized') &&
                el.classList.contains('jet-listing-grid__slider')
            ) {
                tryFix(el);
            }
        });
    });

    observer.observe(container, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
    });

    // Fallback: Swiper may already be initialized before this runs
    container.querySelectorAll('.jet-listing-grid__slider.swiper-initialized').forEach(tryFix);
}
